export const SETTINGS_TABS = [
  { to: '/settings/account', label: 'Account' },
  { to: '/settings/organization', label: 'Organization' },
  { to: '/settings/members', label: 'Members' },
  { to: '/settings/keys', label: 'API keys' },
  { to: '/settings/credentials', label: 'Credentials' },
  { to: '/settings/domains', label: 'Domains' },
  { to: '/settings/storage', label: 'Storage' },
  { to: '/settings/ai-usage', label: 'AI usage' },
  { to: '/settings/notifications', label: 'Notifications' },
] as const;

export type TSettingsTab = (typeof SETTINGS_TABS)[number]['to'];
